import { declareVueComponent } from '../vvuejs/vueRegister.mjs'

import FNotificationSpace from './components/FNotificationSpace.vue'
declareVueComponent('FNotificationSpace', FNotificationSpace)

// export * as notificationService from './vnotification.service.mjs'